import PropTypes from 'prop-types';
import Navbar from '../Common/Navbar';
import Footer from '../Common/Footer';
import { useNavbar } from '../../context/NavbarContext';

const Layout = ({ children }) => {
  const { variant } = useNavbar();

  return (
    <div className="flex flex-col min-h-screen">
      {/* <Navbar /> */}
      <Navbar variant={variant} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;